module.exports = __webpack_public_path__ + "../resources/img/home.961a2093.svg";